import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const PostsList = styled.ul`
  display: flex;
  flex-direction: column;
  max-height: 550px;
  overflow-y: auto;
  gap: ${SPACING._16};
  width: 100%;
  scrollbar-width: thin;
`;
